/**
 * Turn an uploaded 50-Tawi certificate into what LLMR-235's
 * POST /topups/wht-claims needs: a data URL. Unlike a bank slip (always a
 * phone photo), a withholding-tax certificate is routinely a scanned PDF —
 * see member-api's decodeWHTDocDataURL, which this mirrors on the accepted
 * MIME types and size cap.
 */

/** 10 MiB, matching member-api's maxWHTDocBytes. */
export const MAX_WHT_DOC_BYTES = 10 * 1024 * 1024;

const ACCEPTED_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'application/pdf']);

export class WHTDocFileError extends Error {}

/** Reads a File as a data:image/...|application/pdf;base64,... URL. */
export function readWHTDocFile(file: File): Promise<string> {
  if (!ACCEPTED_TYPES.has(file.type)) {
    return Promise.reject(new WHTDocFileError('unsupported_type'));
  }
  if (file.size > MAX_WHT_DOC_BYTES) {
    return Promise.reject(new WHTDocFileError('too_large'));
  }
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (typeof reader.result === 'string') resolve(reader.result);
      else reject(new WHTDocFileError('read_failed'));
    };
    reader.onerror = () => reject(new WHTDocFileError('read_failed'));
    reader.readAsDataURL(file);
  });
}
